export const members = [
	{
		role: 'maintainer',
		status: 'pending',
		userHandler: 'zeque@codigo.ai'
	},
	{
		role: 'maintainer',
		status: 'pending',
		userHandler: 'lauti@codigo.ai'
	},
	{
		role: 'maintainer',
		status: 'pending',
		userHandler: 'pablillo@codigo.ai'
	}
]
